import { render, staticRenderFns } from "./DeliveryNote.vue?vue&type=template&id=92a3fd16&"
import script from "./DeliveryNote.vue?vue&type=script&lang=js&"
export * from "./DeliveryNote.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryNote.vue?vue&type=style&index=0&id=92a3fd16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports